// src/utils/errors.js
// Plain-language messages for the backend error contract ({code, message, retry_after, runs_left}).

const minutes = (s) => Math.max(1, Math.round((s || 60) / 60));

export function friendlyError(err, fallback = "Something went wrong.") {
  if (!err) return fallback;
  switch (err.code) {
    case "network":
      return "You appear to be offline. Your changes are kept in this browser and will be saved when you are back online.";
    case "session_limit":
      return "You have used all AI generations for this step in this journey. You can still edit the result yourself.";
    case "rate_limited":
      return `Too many requests from your network. Please try again in about ${minutes(err.retryAfter)} minute(s).`;
    case "daily_cap":
      return "The assistant has reached today's limit, please try again tomorrow.";
    case "in_progress":
      return "The AI is already working on this journey. Please wait for it to finish.";
    case "llm_unavailable":
      return "The AI could not generate a result right now. Please try again in a few minutes.";
    case "human_check_required":
      return "Please complete the quick human check first.";
    case "prerequisites":
      return err.neededSteps?.length
        ? `Please confirm step${err.neededSteps.length > 1 ? "s" : ""} ${err.neededSteps.join(", ")} first.`
        : err.message;
    case "validation_error": {
      const fields = err.fieldErrors ? Object.entries(err.fieldErrors) : [];
      if (!fields.length) return err.message || fallback;
      return fields.map(([f, m]) => `${f.replace(/_/g, " ")}: ${m}`).join(" · ");
    }
    case "no_session":
      return "Your session has ended. Please start a new journey or open your resume link.";
    default:
      return err.message || fallback;
  }
}
